/**
 * components/client/SaveIndicator.tsx
 *
 * Persistent save status indicator for the client form.
 * Shows "Sauvegardé" (check icon) or "Sauvegarde..." (animated cloud icon)
 * depending on whether a save is currently in flight.
 *
 * Updated June 2026: Text always visible on all screen sizes (no hidden on mobile).
 * Uses CloudUpload icon with a bobbing animation during save to clearly communicate
 * an upload action is in progress. Added role=status + aria-live=polite for
 * screen reader announcements.
 */

import { UploadCloud, Check } from 'lucide-react';

interface SaveIndicatorProps {
  isSaving: boolean;
}

export default function SaveIndicator({ isSaving }: SaveIndicatorProps) {
  return (
    <div className="flex items-center gap-1.5 select-none" role="status" aria-live="polite">
      {isSaving ? (
        <>
          <UploadCloud className="w-4 h-4 text-neutral-400 animate-cloud-upload flex-shrink-0" />
          <span className="text-[11px] text-neutral-400 font-medium">Sauvegarde...</span>
        </>
      ) : (
        <>
          <Check className="w-4 h-4 text-success-500 flex-shrink-0" />
          <span className="text-[11px] text-success-600 font-medium">Sauvegardé</span>
        </>
      )}
    </div>
  );
}
